import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const OcularSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  return (
    <>
      <Col span={24}>
        <Text>
          {`4. ${t('epidemiology.ocular')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${symptoms.ocular?.status}`)}
          </Text>
        </Text>
      </Col>

      {symptoms.ocular?.status === 'yes' && (
        <>
          {symptoms.ocular.conjunctivitis?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.ocular.conjunctivitis')}</Text>
            </Col>
          )}

          {symptoms.ocular.photophobia?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.ocular.photophobia')}</Text>
            </Col>
          )}

          {symptoms.ocular.diplopia?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.ocular.diplopia')}</Text>
            </Col>
          )}

          {symptoms.ocular.conjunctivalCongestion?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.ocular.conjunctivalCongestion')}
              </Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
